import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, NgZone, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';

import { Router } from '@angular/router';
import { ApplicationPage } from '../../models/application-form.model';
import { DocUploadModal } from '../../models/doc-upload.model';
import { DocUploadService } from '../../services/doc-upload.service';
import { LeadFormService } from '../../services/lead-form.service';
import { constants } from '../../utitlity/constant';
import { Helper } from '../../utitlity/helper';
import { CameraComponent } from '../camera/camera.component';
import { InfoModalComponent } from '../popup-modals/info-modal/info-modal.component';
import { DocObj } from '../../models/doc-upload.model';

@Component({
  selector: 'app-tax-form',
  template: require('./tax-form.component.html'),
  styles: [require('./tax-form.component.css')]
})
export class TaxFormComponent implements OnInit {

  applicationAEMResponse: any;
  questions: any;
  isLoaded: boolean;
  isFeedbackForm: boolean;
  showThankyou: boolean;
  thankyoupage: any;
  leadFormDetails: any;
  @ViewChild('arnFailedModal') arnFailedModal: InfoModalComponent;
  disableFormField: boolean = false;

  validArn: boolean = false;
  @Output() changeEvent: EventEmitter<any> = new EventEmitter<any>();
  toggleBool: boolean = false;

  isDocUploadDone: boolean = false;
  checkingDocumentStatus: boolean;
  appRef: string;
  docUploadSuccess: boolean = false;

  infoPopupMessage = {
    message: '',
  }

  // docUploadData: any[] = [
  //     {
  //       "docInfo": [
  //         {
  //           "docName": "",
  //           "docCode": "PAS",
  //           "docLimit": "1",
  //           "docIndex": [
  //             {
  //               "fileName": "",
  //               "fileNetId": "",
  //               "index": "PAS_1",
  //               "fileContent": "File Content"
  //             }
  //           ]
  //         }
  //       ]
  //     }



  // ];
  docUploadData: any;
  uploads: { id: number; file?: File }[] = [];
  nextId = 1;
  uploadSuccesful: boolean = false;

  constructor(private leadFormService: LeadFormService,
    private router: Router,
    private zone: NgZone, private docUploadService: DocUploadService,

  ) {
  }
  ngOnInit() {
    this.initialiseObjects();
    this.getDocumentData();
    //  this.getJson();
  }

  initialiseObjects() {

    this.isLoaded = false;
    this.showThankyou = false;
    this.isFeedbackForm = false;
    this.leadFormDetails = new Object();
    Helper.enableSpinner(true);
    this.leadFormService.getTaxFormData()
      .then((response) => {
        this.applicationAEMResponse = JSON.parse(JSON.stringify(response));
        let modifiedAppData = new ApplicationPage(this.applicationAEMResponse);
        this.questions = modifiedAppData.applicationForm.sections;
        Helper.enableSpinner(false);
        this.isLoaded = true;

      }, (err) => {
        Helper.enableSpinner(false);
        this.router.navigate(['error']);
      });

    Helper.enableSpinner(true);
    this.leadFormService.getARN().then((data) => {
      this.appRef = data.arnNumber;
      Helper.enableSpinner(false);
    });

  }
  redirectPageTo(page) {
    Helper.enableSpinner(false);
    this.zone.run(() => {
      this.router.navigate([page]);
    });
  }

  onFieldChange(event) {
    this.changeEvent.emit(event);
  }
  onTypeaheadFieldChange(event) {
  }
  getRows(panel) {
    return Object.keys(panel.panelRows);
  }
  getKeys(pnl) {
    return Object.keys(pnl);
  }


  createLeadFormRequestObject() {
    let panelRows = this.questions[0]["panels"][0]["Panel1"]["panelRows"];
    let panelRowsLength = Object.keys(panelRows).length;

    for (let i = 1; i <= panelRowsLength; i++) {
      for (let item of panelRows['Row' + i]) {
        if (item["backendField"] && item["backendField"] != '' && item["show"]) {
          this.leadFormDetails[item["backendField"]] = item["value"];
        }
      }
    }
    //this.leadFormDetails["mobileCountryCode"] = sessionStorage.getItem("countryCode") || '971';
  }

  onSubmit() {
    Helper.enableSpinner(true);


    if (!this.appRef) {
      this.createLeadFormRequestObject();
      let leadFormDetails = JSON.parse(JSON.stringify(this.leadFormDetails));

      let finalLeadFormDetails = { ...leadFormDetails };
      console.log("finalLeadFormDetails>>>>>>>>>>>>", finalLeadFormDetails)

      this.docUploadService.validateEmiratesID(finalLeadFormDetails)

        .then(res => {

          this.appRef = res.applicationReferenceNumber;


          Helper.enableSpinner(false);
          this.showThankyou = true;


        }
          , err => {
            Helper.enableSpinner(false);
            if (err instanceof HttpErrorResponse) {

              if (err.status === 400) {
                if (err["error"]["status"] === 'STPPOA01') {
                  this.infoPopupMessage.message = constants.POA_ERROR_MSG;
                  this.arnFailedModal.show();
                }
                else if (err["error"]["status"] === 'STPARMX01') {
                  alert("Application is in progress");
                }
                else if (err["error"]["status"] == 'Customer not found') {
                  alert("Customer not found");
                }

              }
              else {
                this.router.navigate(['error']);
              }
            }


          })


    }
    else {
      Helper.enableSpinner(false);
    }
  }

  checkboxChangeEvent(event) {

    if (event) {
      this.toggleBool = true;
    }
    else {
      this.toggleBool = false;
    }
  }



  checkIfAllDone(e) {
    if (e === "doc-upload") {
      this.isDocUploadDone = true;
    }
  }

  onFailureUpload(uploadData: any) {

    if (uploadData.type == "success") {
      this.docUploadSuccess = true;
      console.log("success data");
      console.log(uploadData);
    }
    else if (uploadData.type == "delete") {
      this.docUploadSuccess = false;
    }
    else {
      this.docUploadSuccess = false;
      console.log("failure data");
      console.log(uploadData);
    }

  }
  addUpload() {
    let i = this.docUploadData.docRec.length + 1;

    if (this.docUploadData && this.docUploadData.docRec.length < 3) {
      this.docUploadData.docRec
        .push({

          "docInfo": [
            {
                "docName": "",
                "docCode": "CRSD",
                "docLimit": "1",
                "docIndex": [
                    {
                        "fileName": "",
                        "fileNetId": "",
                        "index": "CRSD_1",
                        "fileContent": "File Content"
                    }
                ]
            }
        ]


        });

        const updatedDocList = JSON.parse(JSON.stringify(this.docUploadData));

        this.docUploadData = new DocUploadModal(this.docUploadData);
    }


  }


  getDocumentData() {

    Helper.enableSpinner(true);

    this.leadFormService.getDocumentList()
      .then((documentList: any) => {

        documentList.arnNo = localStorage.getItem('appRef');

        const updatedDocList = JSON.parse(JSON.stringify(documentList));

        this.docUploadData = new DocUploadModal(documentList);
        Helper.enableSpinner(false);
      }, err => {
        Helper.enableSpinner(false);
        this.router.navigate(['error']);

      });

  }
  documentAction(documentObj) {
    let fileObj: DocObj = documentObj.documentSelected;
    let param;
    Helper.enableSpinner(true);
    this.actionType(documentObj);
  }

  actionType(documentObj) {
    switch (documentObj.type) {
      case 'upload':
        this.uploadDocument(documentObj);

        break;
      case 'delete':
        this.deleteDocument(documentObj);
    }
  }
  uploadDocument(documentObj) {
    let fileObj;
    //Helper.enableSpinner(true);
    if (documentObj.docObj) {
      fileObj = documentObj.docObj;
    }
    else if (documentObj.documentSelected && documentObj.documentSelected.files.length > 0) {
      fileObj = documentObj.documentSelected.files[0].file;
    }
    let fileName: string = documentObj.docObj ? documentObj.docObj.name : documentObj.documentSelected && documentObj.documentSelected.files[0].fileName;
    let param = {
      file: fileObj,
      mapAsJson: {
        docCode: documentObj.documentSelected.docCode,
        docName: fileName,
        arnNo:'21687535438485116',//this.appRef,//'21687535438485116',//this.applicationData.appRefNumber,
        docIndex: documentObj.docIndex
      }
    }
    let formData = new FormData();
    formData.append('file', param.file);
    formData.append('mapAsJson', JSON.stringify(param.mapAsJson));
    this.uploadSuccesful = false;
    this.docUploadService.uploadDocument(formData)
      .then(() => {
        this.docUploadService.getDocUploadApiMessage('Document Upload is successful.', 'success');
      
      //  documentObj.documentSelected.docUploadMsg = this.docUploadService.getDocUploadApiMessage('Document Upload is successful.', 'success');
        this.docUploadService.clearDocUploadMsg(documentObj.documentSelected);
        
        this.uploadSuccesful = true;        
        Helper.enableSpinner(false);

      }, (err) => {
        //.documentSelected.docUploadMsg = this.docUploadService.getDocUploadApiMessage('Document Upload failed.', 'danger');
        this.docUploadService.clearDocUploadMsg(documentObj.documentSelected);

        Helper.enableSpinner(false)

      })
  }

  deleteDocument(documentObj) {
    this.docUploadData.docRec.splice(documentObj.index,1);   
        Helper.enableSpinner(false);


  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/tax-form/tax-form.component.ts